module.exports = __webpack_public_path__ + "static/media/grayClock.df705366.svg";